import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { getAppStatus, MOUNTED } from 'single-spa';

export function useMountGuard({ mfName, mfEnabled }: { mfName: string; mfEnabled: boolean }) {
    const history = useHistory();

    const isMounted = getAppStatus(mfName) === MOUNTED;

    useEffect(() => {
        if (isMounted && mfEnabled === false) {
            history.replace('/');
        }
    }, [mfEnabled, isMounted, history]);
}
